import { PURCHASING_FLAGS } from '@notifi/shared-types/feature-flags';
import { createFileRoute } from '@tanstack/react-router';
import { RequireFeatureFlag } from '@/features/feature-flags/RequireFeatureFlag';
import { PurchasingSettingsPage } from '@/features/purchasing/PurchasingSettings';

/** Purchasing settings sit behind the purchasing flag (PLAT-FF-1), like the pages. */
function PurchasingSettingsArea() {
  return (
    <RequireFeatureFlag flag={PURCHASING_FLAGS.purchaseOrders} title="Purchasing">
      <PurchasingSettingsPage />
    </RequireFeatureFlag>
  );
}

export const Route = createFileRoute('/_dashboard/dashboard/settings/purchasing')({
  component: PurchasingSettingsArea,
});
